<template>
  <b-form-group>
    <label>Description</label>
    <VInput
      v-model="orderInfo.description"
      type="text"
      :rules="rules.description"
      vid="customer_reference"
      name="Description"
      placeholder="Description"
    />
  </b-form-group>
  <b-form-group v-if="assignment.assignment_type !== SINGLE">
    <label>Message</label>
    <textarea v-model="orderInfo.message" class="form-control" placeholder="Message" rows="5" />
  </b-form-group>
  <b-form-group>
    <label class="fs-xl">Invoice Reference</label>
    <VInput
      v-model="orderInfo.customer_reference"
      type="text"
      :rules="{ required: false }"
      vid="customer_reference"
      name="customer_reference"
      placeholder="Here you can add a reference for your account administrator or billing administrator"
    />
  </b-form-group>
</template>

<script lang="ts">
import type { AssignmentCreationData } from '@/types/Models/Assignment'
import { BFormGroup } from 'bootstrap-vue-next'
import { ref, computed, defineComponent, watch, type ComputedRef, type Ref } from 'vue'
import { useValidationRules } from '@/composables/AssignmentForm/useValidationRules'
import { SINGLE } from '@/const/AssignmentTypes'
import { useAssignmentFormStore } from '@/store/assignmentForm'
import VInput from '@/views/Components/Elements/Form/VInput.vue'

export default defineComponent({
  name: 'OrderInfo',
  components: { BFormGroup, VInput },
  setup() {
    const assignmentFormStore = useAssignmentFormStore()
    const orderInfo: Ref<Partial<AssignmentCreationData>> = ref({
      description: '',
      message: '',
      customer_reference: '',
    })

    const assignment: ComputedRef<AssignmentCreationData> = computed(() => assignmentFormStore.assignment)
    const rules = useValidationRules(assignment)

    watch(orderInfo, (value) => assignmentFormStore.setFields(value), { deep: true })

    watch(
      assignment,
      (value: AssignmentCreationData) => {
        if (value.description !== orderInfo.value.description) {
          orderInfo.value.description = value.description
        }
        if (value.message !== orderInfo.value.message) {
          orderInfo.value.message = value.message
        }
        if (value.customer_reference !== orderInfo.value.customer_reference) {
          orderInfo.value.customer_reference = value.customer_reference
        }
      },
      { deep: true },
    )

    return {
      rules,
      assignment,
      orderInfo,
      SINGLE,
    }
  },
})
</script>
